module.exports = __webpack_public_path__ + "static/pic01-e728cd3e575ab0cdb887c62a4006723a.jpg";